enum ABTestFlag {
    TakePhoto = 'TAKE_PHOTO',
    VideoStream = 'VIDEO_STREAM',
}

export class ABTest {
    readonly flag: string

    constructor() {
        this.flag = ABTestFlag.TakePhoto
    }
}
